import React, { useState } from "react";
import { Button, Grid, TextField } from "@mui/material";
import MDButton from "components/MDButton";
import { forceCheckout } from "../../../../redux/actions/RatActions";
import { useDispatch } from "react-redux";

const ForceCheckoutReason = (props) => {
  const [reason, setReason] = useState("");
  const dispatch = useDispatch();
  let data = {
    checkOutExceptionalDue: props.guestdetails.dueAmount,
    checkOutExceptionalMessage: reason,
  };
  const forecedCheckout = () => {
    dispatch(forceCheckout(props.guestdetails.id, data));
    props.editGuestHandler();
    props.handleCloseGuestModalWindow();
  };
  return (
    <div>
      <p>Reason For ForceCheckout</p>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            style={{ width: "100%" }}
            id="outlined-multiline-static"
            label="Reason For ForceCheckout minimum of 50 chars"
            multiline
            rows={4}
            onChange={(e) => setReason(e.target.value)}
          />
        </Grid>
        <Grid>
          <MDButton size="small" color="info" onClick={forecedCheckout}>
            Complete Force CheckOut
          </MDButton>
        </Grid>
      </Grid>
    </div>
  );
};

export default ForceCheckoutReason;
